import { render, staticRenderFns } from "./BlendForm.vue?vue&type=template&id=1264981e"
import script from "./BlendForm.vue?vue&type=script&lang=js"
export * from "./BlendForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports